import React from 'react';
import ReactDOM from 'react-dom';
import * as immutable from 'immutable';

var Lookup = React.createClass({
	propTypes: {
		// Data for Select2,
		dataSet: React.PropTypes.array.isRequired,

		// If true apply the prop `errorClass`
		hasError: React.PropTypes.bool,

		// Class to apply if hasError is true.
		errorClass: React.PropTypes.string,

		// Function to call with currently selected elements
		onSelection: React.PropTypes.func,

		// Allow multiple selections
		multiple: React.PropTypes.bool,

		// Placeholder to display in select
		placeholder: React.PropTypes.string,


		// inline style for select
		styleWidth: React.PropTypes.string,

		// enable or disable the input
		enabled: React.PropTypes.bool
	},

	getDefaultProps: function () {
		return {
			hasError: false,
			errorClass: "has-error",  // default to Bootstrap 3's error class
			multiple: false,
			placeholder: ' ',
			value: null,
			styleWidth: "100%",
			enabled: true,
			minLength: 0,
			debouce: 200,
			clearable: true,
			dataSet: []
		};
	},


	///////////////////////////////
	// Lifecycle
	///////////////////////////////
	componentDidUpdate: function (prevProps, prevState) {
		if (this._isDataUpdated(prevProps.dataSet)) {
			// "brute-force" new data into our Select2 widget since Select2 doesn't
			// have a method for changng data on already-existing widgets
			this.createSelect2();
		} else {
			// Change placeholder
			if (prevProps.placeholder !== this.props.placeholder) {
				this.setPlaceholderTo(this.getInputElem(), this.props.placeholder);
			}

			// Handle val prop
			/*var updateVal = false;
			// ...if length of old val prop and new val prop arrays are the same,
			//    we'll need to check the elements
			if (prevProps.value.length == this.props.value.length) {
				$.each(prevProps.value, function (index, value) {
					if (this.props.value[index] != value) {
						updateVal = true;
					}
				}.bind(this));

			} else {
				updateVal = true;
			}
			// ...update our val if we need to
			if (updateVal) {

			}*/
			const value = (this.props.value instanceof immutable.Map || this.props.value instanceof immutable.List) ? this.props.value.toJS() : this.props.value;
			let val;
			if( Object.prototype.toString.call(value) === '[object Array]' ) {
				if (value.length > 0 && !this.props.multiple) {
					val = value[0];
				}
				else {
					val = value;
				}
			}
			else {
				val = this.props.multiple ? (value ? [value] : []) : value;
			}
			this.getInputElem().select2("val", val);

			// Enable/disable
			if (prevProps.enabled != this.props.enabled) {
				this.getInputElem().select2("enable", this.props.enabled);
			}
		}
	},

	componentDidMount: function () {
		// Set up Select2
		var $node = this.createSelect2();
	},

	componentWillUnmount : function () {
		$(ReactDOM.findDOMNode(this.refs.input)).select2("destroy");
	},

	///////////////////////////////
	// Manipulate Select2
	///////////////////////////////
	setPlaceholderTo: function($elem, placeholder) {
		if (!placeholder) {
			placeholder = "";
		}
		var currData = $elem.select2("data");

		// Set placeholder to new placeholder
		$elem.attr("placeholder", placeholder);

		// Now workaround the fact that Select2 doesn't pick up on this
		// ..First assign null
		//$elem.select2("data", null);

		// ..Then assign dummy value in case that currData is null since
		//   that won't do anything.

		/*$elem.select2("data", {});*/

		// ..Then put original data back
		//$elem.select2("data", currData);
	},

	getValue: function() {
		var $node = this.getInputElem();
		return $node.data('value') !== null ? $node.data('value') : undefined;
	},

	createSelect2: function () {
		var me = this;
		// Get inital value
		var val = null;
		const value = (this.props.value instanceof immutable.Map || this.props.value instanceof immutable.List) ? this.props.value.toJS() : this.props.value;
		if( Object.prototype.toString.call(value) === '[object Array]' ) {
			if (value.length > 0 && this.props.multiple) {
				val = value[0];
			}
			else {
				val = value;
			}
		}
		else {
			val = this.props.multiple ? (value ? [value] : []) : value;
		}

		var options = {
			data: this.props.dataSet,
			minimumInputLength: this.props.minLength,
			multiple: this.props.multiple,
			//val: val,
			dropdownWidth: this.props.dropdownWidth,
			allowClear: this.props.clearable
		};

		if (this.props.formatResult) {
			options.formatResult = this.props.formatResult;
		}
		if (this.props.formatSelection) {
			options.formatSelection = this.props.formatSelection;
		}

		options.initSelection = (element, callback) => {
			var value = element.data('value');
			if (this.props.multiple && !value) {
				callback([]);
				return;
			}
			/*if (typeof value === 'undefined') {
				callback(null);
				return;
			}
			if (value === undefined) {
				callback(null);
				return;
			}*/
			return callback(value);
		}

		options.query = (query) => {
			window.clearTimeout(this.timeout);
			this.timeout = window.setTimeout(() => {
				this.props.query(query.term, query.page).then(function (data) {
					query.callback(data);
				});
			}, !this.firstcall ? 0 : this.props.debouce);
			this.firstcall = true;
		};

		var $node = this.getInputElem();
		$node.attr("autofocus", this.props.autoFocus);
		$node.attr("placeholder", this.props.placeholder);
		$node.
		//val(val).
		select2(options).
		on("change", this.handleChange).
		on("select2-open", this.handleErrorState).
		select2("enable", this.props.enabled);
			$node.select2("val", val);

		/*setTimeout(() => {
		}, 1);*/
		this.setPlaceholderTo($node, this.props.placeholder);
	},

	///////////////////////////////
	// Helpers
	///////////////////////////////
	handleErrorState: function () {
		var $dropNode = $('#select2-drop');
		var classNames = $dropNode[0].className.split(/\s+/);

		if (this.props.hasError) {
			var hasErrorClass = $.inArray(this.props.errorClass, classNames);

			if (hasErrorClass == -1) {
				$dropNode.addClass(this.props.errorClass);
			}

		} else {
			$dropNode.removeClass(this.props.errorClass);
		}
	},

	handleChange: function (e) {
		let value = immutable.fromJS(this.getValue());
		if (typeof value === 'undefined') {
			value = null;
		}
		if (this.props.onChange) {
			this.props.onChange(value)
		}
		if (this.props.onBlur) {
			this.props.onBlur(value)
		}
		this.firstcall = false;
	},

	getInputElem: function () {
		return $(ReactDOM.findDOMNode(this.refs.input));
	},

	_isDataUpdated: function (oldData) {
		// TODO: More robust dataSet checker.  Need to recurse and
		// check all elements of data set.
		if (oldData.length != this.props.dataSet.length) {
			return true;
		}

		return false;
	},

	getError: function() {
		return this.props.error && this.props.error[0];
	},


	render: function () {
		var style = {width: this.props.styleWidth};
		return <div className={this.getError() ? this.props.errorClass : ""}>
				 	<input type="hidden" style={style} ref="input"/>
					{this.getError() && <div className="error-block">{this.getError()}</div>}
		      </div>
	}
});

export default Lookup;


// WEBPACK FOOTER //
// ./src/components/Form/Lookup.js